import { API } from '@Providers';
import { extractInventoryPayload } from '../helpers/equipmentRentalInventory.helpers';
import type { InventoryApiPayload } from '../helpers/equipmentRentalInventory.helpers';

const EQUIPMENT_RENTAL_INVENTORY_ENDPOINT = '/api/shelter/equipment-rental/inventory';

export default async function getEquipmentRentalInventoryService(): Promise<InventoryApiPayload | null> {
  const response = await API({ endpoint: EQUIPMENT_RENTAL_INVENTORY_ENDPOINT });

  return extractInventoryPayload({ data: response });
}
